export default __webpack_public_path__ + "static/media/source-tick.e86bb8ba.svg";